/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_OrInputs */

const en_signin_or = /** @type {(inputs: Signin_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const ar_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const he_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const ur_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const es_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const fr_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const de_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const pt_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const hi_signin_or = en_signin_or;

/** @type {(inputs: Signin_OrInputs) => LocalizedString} */
const bn_signin_or = en_signin_or;

/**
* | output |
* | --- |
* | "or" |
*
* @param {Signin_OrInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_or = /** @type {((inputs?: Signin_OrInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_OrInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_or(inputs)
	if (locale === "he") return he_signin_or(inputs)
	if (locale === "ur") return ur_signin_or(inputs)
	if (locale === "es") return es_signin_or(inputs)
	if (locale === "fr") return fr_signin_or(inputs)
	if (locale === "de") return de_signin_or(inputs)
	if (locale === "pt") return pt_signin_or(inputs)
	if (locale === "hi") return hi_signin_or(inputs)
	if (locale === "bn") return bn_signin_or(inputs)
	return /** @type {LocalizedString} */ ("or")
});